import { Options } from "ky";
import { fetcher } from "../fetcher";
import { Pagination } from "../pagination";
import { Notice } from "./type";

export async function getNotices(options?: Options): Promise<Pagination<Notice>> {
  return await fetcher.get('new-informations', options).json();
}
